<script lang="ts">
  import { invalidateAll } from '$app/navigation';
  import { page } from '$app/stores';
  import type { AlertConfig } from '$types/races';
  import { updateAlertConfig } from '$utils/ui';
  import { onMount } from 'svelte';
  // import { validateTelegramAuth, type TelegramUser } from '$utils/telegram';

  $: ({ layoutConfigStore, user } = $page.data);

  //   allow for storing the telegram id after login in the same session
  // let tid: number | null = null;
  //   track if we have manually logged out (page data is invalid)
  // let hasBeenCleared = false;
  // $: telegramId = hasBeenCleared
  //   ? ''
  //   : user?.data?.user?.alertConfig?.telegramId || tid;

  // Global callback function for Telegram Login Widget
  // const onTelegramAuth = async (userData: TelegramUser) => {
  //   if (userData?.id) {
  //     // Validate the authentication data
  //     const isValid = await validateTelegramAuth(userData);
  //     if (!isValid) {
  //       console.error('Invalid Telegram authentication data');
  //       return;
  //     }

  //     hasBeenCleared = false;
  //     // Store the new telegram user id in the user model
  //     tid = userData.id;
  //     handleAlertConfigChange({ telegramId: userData.id.toString() });
  //   }
  // };

  // Make the callback globally available for the Telegram widget
  // let telegramWidgetContainer: HTMLDivElement;

  // onMount(() => {
  //   // Make the callback function globally available
  //   (window as any).onTelegramAuth = onTelegramAuth;

  //   // Load Telegram Widget script if not already loaded
  //   if (
  //     !document.querySelector(
  //       'script[src="https://telegram.org/js/telegram-widget.js"]'
  //     )
  //   ) {
  //     const script = document.createElement('script');
  //     script.async = true;
  //     script.src = 'https://telegram.org/js/telegram-widget.js?22';
  //     script.setAttribute('data-telegram-login', 'betwatch_bot');
  //     script.setAttribute('data-size', 'medium');
  //     script.setAttribute('data-radius', '5');
  //     script.setAttribute('data-onauth', 'onTelegramAuth(user)');

  //     if (telegramWidgetContainer) {
  //       telegramWidgetContainer.appendChild(script);
  //     }
  //   }

  //   return () => {
  //     // Cleanup global function
  //     delete (window as any).onTelegramAuth;
  //   };
  // });

  // const clearTelegramId = () => {
  //   tid = null;
  //   handleAlertConfigChange({ telegramId: '' });
  //   hasBeenCleared = true;
  // };

  //   if user?.data?.user?.alertConfig.alertSound is null, default to true
  $: if (user?.data?.user?.alertConfig.alertSound === null) {
    user.data.user.alertConfig.alertSound = true;
  }

  async function handleAlertConfigChange(alertConfig: AlertConfig) {
    if (!user?.data) return;
    // any attribute not present in the new alertConfig will be set to its original value
    user.data.user.alertConfig = {
      ...user.data?.user.alertConfig,
      ...alertConfig
    };
    await updateAlertConfig();
    invalidateAll();
  }
</script>

<div class="flex flex-row items-center gap-x-2">
  <div class="flex-1">
    <h2 class="text-base font-semibold leading-7 text-gray-900">
      Alert Configuration
    </h2>
    <p class="mt-1 max-w-2xl text-sm leading-6 text-gray-600">
      Configure where and how alerts are sent. Currently only Telegram is
      supported. Alerts will always be displayed as notifications on the
      website.
    </p>
  </div>
</div>
{#if user?.data?.user?.alertConfig}
  <div
    class="flex w-full flex-col space-y-8 border-b border-gray-900/10 pb-12 sm:space-y-0 sm:divide-y sm:divide-gray-900/10 sm:border-t sm:pb-0"
  >
    <button
      on:click|preventDefault|capture|stopPropagation={() => {
        handleAlertConfigChange({
          alertSound: !user?.data?.user.alertConfig.alertSound
        });
      }}
      class="flex w-full cursor-pointer px-5 text-left hover:bg-gray-50 sm:gap-4 sm:py-6"
    >
      <div class="min-w-0 flex-1 cursor-pointer text-sm">
        <label for="alertSound" class="cursor-pointer font-medium text-gray-700"
          ><span class="font-semibold">Play Sound</span>
          <p id="alertSound-description" class="cursor-pointer text-gray-500">
            Play a sound when an alert is triggered.
          </p>
        </label>
      </div>
      <div class="ml-3 flex h-full cursor-pointer items-center">
        <input
          on:click|preventDefault|capture|stopPropagation
          bind:checked={user.data.user.alertConfig.alertSound}
          id="alertSound"
          aria-describedby="alertSound-description"
          name="alertSound"
          type="checkbox"
          class="h-5 w-5 cursor-pointer rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
        />
      </div>
    </button>
    <!-- <div
      class="flex w-full cursor-pointer px-5 hover:bg-gray-50 sm:gap-4 sm:py-6"
    >
      <div class="min-w-0 flex-1 cursor-pointer text-sm">
        <label
          for="betfairReductionFactor"
          class="cursor-pointer font-medium text-gray-700"
          ><span class="font-semibold">Telegram</span>
          <p
            id="betfairReductionFactor-description"
            class="cursor-pointer text-gray-500"
          >
            Link your Telegram account to receive alerts directly to your
            mobile.<br /><a
              href="https://t.me/betwatch_alert_bot"
              class="font-semibold text-blue-950 hover:text-blue-800"
              >Send a message to @betwatch_alert_bot to get started</a
            >
          </p>
        </label>
      </div>
      <div
        class="relative ml-3 flex h-full cursor-pointer flex-col items-center"
      >
        {#if !telegramId}
          <span class="">Disabled</span>
          <div bind:this={telegramWidgetContainer}></div>
        {:else}
          <span class="text-sm"
            >Enabled with user <span class="font-semibold">{telegramId}</span
            ></span
          >
          <button
            on:click={clearTelegramId}
            class="mt-1 inline-flex w-full items-center justify-center rounded border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Logout
          </button>
        {/if}
      </div>
    </div> -->
    <button
      on:click|preventDefault|capture|stopPropagation={() => {
        handleAlertConfigChange({
          email: !user?.data?.user.alertConfig.email
        });
      }}
      class="flex w-full cursor-pointer px-5 text-left hover:bg-gray-50 sm:gap-4 sm:py-6"
    >
      <div class="min-w-0 flex-1 cursor-pointer text-sm">
        <label for="alertEmail" class="cursor-pointer font-medium text-gray-700"
          ><span class="font-semibold">Email Alerts</span>
          <p id="alertEmail-description" class="cursor-pointer text-gray-500">
            Send an email when an alert is triggered. Email will be sent to your
            registered email address.
          </p>
        </label>
      </div>
      <div class="ml-3 flex h-full cursor-pointer items-center">
        <input
          on:click|preventDefault|capture|stopPropagation
          bind:checked={user.data.user.alertConfig.email}
          id="alertEmail"
          aria-describedby="alertEmail-description"
          name="alertEmail"
          type="checkbox"
          class="h-5 w-5 cursor-pointer rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
        />
      </div>
    </button>
    <div
      class="flex w-full cursor-pointer px-5 hover:bg-gray-50 sm:gap-4 sm:py-6"
    >
      <div class="min-w-0 flex-1 cursor-pointer text-sm">
        <label
          for="discordWebhookUrl"
          class="cursor-pointer font-medium text-gray-700"
          ><span class="font-semibold">Discord Webhook</span>
          <p
            id="discordWebhookUrl-description"
            class="cursor-pointer text-gray-500"
          >
            Configure a Discord webhook URL to receive alerts in a Discord
            channel.
            <br /><a
              href="https://support.discord.com/hc/en-us/articles/228383668-Intro-to-Webhooks"
              class="font-semibold text-blue-950 hover:text-blue-800"
              target="_blank"
              rel="noopener noreferrer">Learn how to create a Discord webhook</a
            >
          </p>
        </label>
      </div>
      <div
        class="relative ml-3 flex h-full cursor-pointer flex-col items-center"
      >
        <input
          bind:value={user.data.user.alertConfig.discordWebhookUrl}
          on:input={() => {
            handleAlertConfigChange({
              discordWebhookUrl: user.data.user.alertConfig.discordWebhookUrl
            });
          }}
          id="discordWebhookUrl"
          aria-describedby="discordWebhookUrl-description"
          name="discordWebhookUrl"
          type="url"
          placeholder="https://discord.com/api/webhooks/..."
          class="w-64 rounded border border-gray-300 px-3 py-2 text-sm shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
        />
      </div>
    </div>
  </div>
{/if}
